import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import PrimevueLocale from './vue/primevueLocale';
import BranchContact from "./vue/branchContact.vue";

const branchContactAppSelector = "#branchContactApp";
const branchContactAppElement = document.querySelector(branchContactAppSelector);
if (branchContactAppElement) {
    const branch = JSON.parse(branchContactAppElement.dataset.branch);
    const shops = JSON.parse(branchContactAppElement.dataset.shops);
    const brands = JSON.parse(branchContactAppElement.dataset.brands);

    const seedData = {
        branch: branch,
        brands: brands,
        shops: shops
    };

    const branchContact = createApp({
        data() { return seedData },
        render: () => h(BranchContact)
    }, seedData);

    branchContact.use(PrimeVue,{
        locale:PrimevueLocale.locale
    });
    branchContact.mount(branchContactAppSelector);

}
